"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DateTimeGeneralHandler", {
    enumerable: true,
    get: function() {
        return DateTimeGeneralHandler;
    }
});
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _timezone = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/timezone"));
const _utc = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/utc.js"));
const _nocodbsdk = require("nocodb-sdk");
const _debug = /*#__PURE__*/ _interop_require_default(require("debug"));
const _catchError = require("~/helpers/catchError");
const _generic = require("~/db/field-handler/handlers/generic");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
_dayjs.default.extend(_utc.default);
_dayjs.default.extend(_timezone.default);
const dateTimeHandlerDebug = (0, _debug.default)('nc:DateTimeGeneralHandler');
let DateTimeGeneralHandler = class DateTimeGeneralHandler extends _generic.GenericFieldHandler {
    async verifyFilter(filter, column) {
        const supportedOperations = [
            'gb_eq',
            'gb_null',
            'eq',
            'neq',
            'not',
            'empty',
            'notempty',
            'null',
            'notnull',
            'blank',
            'notblank',
            'gt',
            'lt',
            'gte',
            'lte',
            'ge',
            'le',
            'isnot',
            'is',
            'isWithin'
        ];
        if (!supportedOperations.includes(filter.comparison_op)) {
            return {
                isValid: false,
                errors: [
                    `Operation ${filter.comparison_op} is not supported for type ${column.uidt} on column ${column.title}`
                ]
            };
        }
        if (filter.comparison_sub_op === 'exactDate' || !filter.comparison_sub_op) {
            // check if value is not null or empty
            if (!(filter.value === null || typeof filter.value === 'undefined' || filter.value === '' || filter.comparison_op === 'in' && Array.isArray(filter.value))) {
                const dateTimeValue = await (0, _nocodbsdk.parseDateTimeValue)(filter.value, {
                    col: column
                });
                if (dateTimeValue === null || typeof dateTimeValue === 'undefined') {
                    return {
                        isValid: false,
                        errors: [
                            `Value ${filter.value} is not supported for type ${column.uidt} on column ${column.title}`
                        ]
                    };
                }
            }
        }
        return {
            isValid: true
        };
    }
    parseDateTime(params) {
        // Allow null/undefined/empty values
        if (params.value === null || params.value === undefined || params.value === '') {
            return {
                value: null
            };
        }
        let dayjsUtcValue;
        if (params.value instanceof Date || typeof params.value === 'string' || typeof params.value === 'number') {
            if (params.value instanceof Date) {
                dayjsUtcValue = (0, _dayjs.default)(params.value).utc();
            } else if (typeof params.value === 'string') {
                var _params_column_meta;
                let strVal = params.value;
                if (strVal.indexOf('-') < 0 && strVal.indexOf('+') < 0 && strVal.slice(-1) !== 'Z') {
                    // if no timezone is given,
                    // then append +00:00 to make it as UTC
                    strVal += '+00:00';
                }
                dayjsUtcValue = (0, _dayjs.default)(strVal).utc();
                if (!dayjsUtcValue.isValid() && ((_params_column_meta = params.column.meta) == null ? void 0 : _params_column_meta.date_format)) {
                    var _params_column_meta1;
                    dayjsUtcValue = (0, _dayjs.default)(strVal, (_params_column_meta1 = params.column.meta) == null ? void 0 : _params_column_meta1.date_format).utc();
                }
            } else if (typeof params.value === 'number') {
                dayjsUtcValue = _dayjs.default.unix(params.value).utc();
            }
        }
        if (!dayjsUtcValue || !dayjsUtcValue.isValid()) {
            _catchError.NcError.invalidValueForField({
                value: params.value,
                column: params.column.title,
                type: params.column.uidt
            });
        }
        return {
            value: dayjsUtcValue
        };
    }
    async parseUserInput(params) {
        var _this_parseDateTime_value;
        return {
            value: (_this_parseDateTime_value = this.parseDateTime(params).value) == null ? void 0 : _this_parseDateTime_value.format('YYYY-MM-DD HH:mm:ssZ')
        };
    }
    getTimezone(_knex, filter, column, options) {
        const { context } = options;
        const timezone = (0, _nocodbsdk.getNodejsTimezone)((0, _nocodbsdk.parseProp)(filter.meta).timezone, (0, _nocodbsdk.parseProp)(column.meta).timezone, context.timezone);
        dateTimeHandlerDebug('timezone: ' + JSON.stringify([
            (0, _nocodbsdk.parseProp)(filter.meta).timezone,
            (0, _nocodbsdk.parseProp)(column.meta).timezone,
            context.timezone
        ]));
        return timezone;
    }
    parseFilterValue(value, _knex, filter, column, options) {
        // if the time provided has timezone, return as is
        if ((0, _nocodbsdk.isDateTimeStringHasTimezone)(value)) {
            const result = (0, _dayjs.default)(value).tz(this.getTimezone(_knex, filter, column, options));
            dateTimeHandlerDebug('parseFilterValue ' + value + ' DateTimeStringHasTimezone: ' + result + ' ' + result.format(this.dateValueFormat));
            return result;
        } else {
            const result = _dayjs.default.tz(value, this.getTimezone(_knex, filter, column, options));
            dateTimeHandlerDebug('parseFilterValue ' + value + ' withoutTimezone: ' + result + ' ' + result.format(this.dateValueFormat));
            return result;
        }
    }
    getNow(_knex, filter, column, options) {
        const now = _dayjs.default.tz(new Date(), this.getTimezone(_knex, filter, column, options));
        if (filter.groupby) {
            return now.startOf('minute');
        }
        // the val will be start of day in timezone
        return now.startOf('day');
    }
    comparisonBetween({ sourceField, anchorDate, rangeDate, qb }, { knex }, _options) {
        qb.where(knex.raw('?? between ? and ?', [
            sourceField,
            anchorDate.utc().format(this.dateValueFormat),
            rangeDate.utc().format(this.dateValueFormat)
        ]));
    }
    comparisonOp({ sourceField, val, qb, comparisonOp }, { knex }, _options) {
        qb.where(knex.raw(`?? ${comparisonOp} ?`, [
            sourceField,
            val.utc().format(this.dateValueFormat)
        ]));
    }
    async filter(knex, filter, column, options) {
        var _options_customWhereClause;
        const { alias } = options;
        const field = (_options_customWhereClause = options.customWhereClause) != null ? _options_customWhereClause : alias ? `${alias}.${column.column_name}` : column.column_name;
        const now = this.getNow(knex, filter, column, options);
        let anchorDate;
        const emptyResult = {
            clause: ()=>{}
        };
        // handle sub operation
        switch(filter.comparison_sub_op){
            case 'today':
                anchorDate = now;
                break;
            case 'tomorrow':
                anchorDate = now.add(1, 'day');
                break;
            case 'yesterday':
                anchorDate = now.add(-1, 'day');
                break;
            case 'oneWeekAgo':
                anchorDate = now.add(-1, 'week');
                break;
            case 'oneWeekFromNow':
                anchorDate = now.add(1, 'week');
                break;
            case 'oneMonthAgo':
                anchorDate = now.add(-1, 'month');
                break;
            case 'oneMonthFromNow':
                anchorDate = now.add(1, 'month');
                break;
            case 'daysAgo':
                if (!filter.value) return emptyResult;
                anchorDate = now.add(-filter.value, 'day');
                break;
            case 'daysFromNow':
                if (!filter.value) return emptyResult;
                anchorDate = now.add(Number(filter.value), 'day');
                break;
            case 'exactDate':
                if (!filter.value) return emptyResult;
                anchorDate = this.parseFilterValue(filter.value, knex, filter, column, options);
                anchorDate = filter.groupby ? anchorDate : anchorDate.startOf('day');
                dateTimeHandlerDebug('exactDate anchorDate ' + anchorDate.format(this.dateValueFormat));
                break;
            // sub-ops for `isWithin` comparison
            case 'pastWeek':
                anchorDate = now.add(-1, 'week');
                break;
            case 'pastMonth':
                anchorDate = now.add(-1, 'month');
                break;
            case 'pastYear':
                anchorDate = now.add(-1, 'year');
                break;
            case 'nextWeek':
                anchorDate = now.add(1, 'week');
                break;
            case 'nextMonth':
                anchorDate = now.add(1, 'month');
                break;
            case 'nextYear':
                anchorDate = now.add(1, 'year');
                break;
            case 'pastNumberOfDays':
                if (!filter.value) return emptyResult;
                anchorDate = now.add(-filter.value, 'day');
                break;
            case 'nextNumberOfDays':
                if (!filter.value) return emptyResult;
                anchorDate = now.add(Number(filter.value), 'day');
                break;
        }
        // for straight date value without sub op
        if (!filter.comparison_sub_op && filter.value) {
            anchorDate = this.parseFilterValue(filter.value, knex, filter, column, options);
            anchorDate = filter.groupby ? anchorDate : anchorDate.startOf('day');
            if (!anchorDate.isValid()) {
                return emptyResult;
            }
        }
        if (filter.comparison_op === 'isWithin') {
            return await this.filterIsWithin({
                val: anchorDate.valueOf(),
                sourceField: field
            }, {
                knex,
                filter,
                column
            }, options);
        }
        return await this.handleFilter({
            val: anchorDate == null ? void 0 : anchorDate.valueOf(),
            sourceField: field
        }, {
            knex,
            filter,
            column
        }, options);
    }
    async filterEq(args, rootArgs, _options) {
        const { knex, filter, column } = rootArgs;
        const anchorDate = _dayjs.default.tz(args.val, this.getTimezone(knex, filter, column, _options));
        const rangeDate = filter.groupby ? anchorDate.add(1, 'minute').add(-1, 'milliseconds') : anchorDate.add(24, 'hours').add(-1, 'milliseconds');
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where((nestedQb)=>{
                    this.comparisonBetween(_extends({}, args, {
                        anchorDate,
                        rangeDate,
                        qb: nestedQb
                    }), rootArgs, _options);
                });
            }
        };
    }
    async filterNeq(args, rootArgs, _options) {
        const anchorDate = (0, _dayjs.default)(args.val);
        const rangeDate = anchorDate.add(24, 'hours').add(-1, 'milliseconds');
        return {
            rootApply: undefined,
            clause: (qb)=>{
                // is earlier than anchor date
                // or later than range date
                // or null
                qb.where((nestedQb)=>{
                    this.comparisonOp(_extends({}, args, {
                        val: anchorDate,
                        qb: nestedQb,
                        comparisonOp: '<'
                    }), rootArgs, _options);
                    nestedQb.orWhere((nestedQb2)=>{
                        this.comparisonOp(_extends({}, args, {
                            val: rangeDate,
                            qb: nestedQb2,
                            comparisonOp: '>'
                        }), rootArgs, _options);
                    });
                    nestedQb.orWhereNull(args.sourceField);
                });
            }
        };
    }
    async filterGt(args, rootArgs, _options) {
        var _rootArgs_filter_value;
        const anchorDate = (0, _dayjs.default)(args.val);
        let rangeDate = anchorDate.add(24, 'hours').add(-1, 'milliseconds');
        // when the given filter value has time component,
        // we use it raw as comparison
        if (typeof rootArgs.filter.value === 'string' && ((_rootArgs_filter_value = rootArgs.filter.value) == null ? void 0 : _rootArgs_filter_value.replace('T', ' ').split(' ')[1])) {
            rangeDate = this.parseFilterValue(rootArgs.filter.value, rootArgs.knex, rootArgs.filter, rootArgs.column, _options);
        }
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where((nestedQb)=>{
                    this.comparisonOp(_extends({}, args, {
                        val: rangeDate,
                        qb: nestedQb,
                        comparisonOp: '>'
                    }), rootArgs, _options);
                });
            }
        };
    }
    async filterGte(args, rootArgs, _options) {
        var _rootArgs_filter_value;
        const anchorDate = (0, _dayjs.default)(args.val);
        let rangeDate = anchorDate;
        // when the given filter value has time component,
        // we use it raw as comparison
        if (typeof rootArgs.filter.value === 'string' && ((_rootArgs_filter_value = rootArgs.filter.value) == null ? void 0 : _rootArgs_filter_value.replace('T', ' ').split(' ')[1])) {
            rangeDate = this.parseFilterValue(rootArgs.filter.value, rootArgs.knex, rootArgs.filter, rootArgs.column, _options);
        }
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where((nestedQb)=>{
                    this.comparisonOp(_extends({}, args, {
                        val: rangeDate,
                        qb: nestedQb,
                        comparisonOp: '>='
                    }), rootArgs, _options);
                });
            }
        };
    }
    async filterLte(args, rootArgs, _options) {
        var _rootArgs_filter_value;
        const anchorDate = (0, _dayjs.default)(args.val);
        let rangeDate = anchorDate.add(24, 'hours').add(-1, 'milliseconds');
        // when the given filter value has time component,
        // we use it raw as comparison
        if (typeof rootArgs.filter.value === 'string' && ((_rootArgs_filter_value = rootArgs.filter.value) == null ? void 0 : _rootArgs_filter_value.replace('T', ' ').split(' ')[1])) {
            rangeDate = this.parseFilterValue(rootArgs.filter.value, rootArgs.knex, rootArgs.filter, rootArgs.column, _options);
        }
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where((nestedQb)=>{
                    this.comparisonOp(_extends({}, args, {
                        val: rangeDate,
                        qb: nestedQb,
                        comparisonOp: '<='
                    }), rootArgs, _options);
                });
            }
        };
    }
    async filterLt(args, rootArgs, _options) {
        var _rootArgs_filter_value;
        const anchorDate = (0, _dayjs.default)(args.val);
        let rangeDate = anchorDate;
        // when the given filter value has time component,
        // we use it raw as comparison
        if (typeof rootArgs.filter.value === 'string' && ((_rootArgs_filter_value = rootArgs.filter.value) == null ? void 0 : _rootArgs_filter_value.replace('T', ' ').split(' ')[1])) {
            rangeDate = this.parseFilterValue(rootArgs.filter.value, rootArgs.knex, rootArgs.filter, rootArgs.column, _options);
        }
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where((nestedQb)=>{
                    this.comparisonOp(_extends({}, args, {
                        val: rangeDate,
                        qb: nestedQb,
                        comparisonOp: '<'
                    }), rootArgs, _options);
                });
            }
        };
    }
    async filterBlank(args, _rootArgs, _options) {
        const { sourceField } = args;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where((nestedQb)=>{
                    nestedQb.whereNull(sourceField);
                });
            }
        };
    }
    async filterNotblank(args, _rootArgs, _options) {
        const { sourceField } = args;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where((nestedQb)=>{
                    nestedQb.whereNotNull(sourceField);
                });
            }
        };
    }
    async filterIsWithin(args, rootArgs, _options) {
        const { knex, filter, column } = rootArgs;
        const anchorDate = (0, _dayjs.default)(args.val);
        const now = this.getNow(knex, filter, column, _options);
        let firstArg;
        let secondArg;
        if (now.isBefore(anchorDate)) {
            firstArg = now.startOf('day');
            secondArg = anchorDate.add(24, 'hours').add(-1, 'millisecond');
        } else {
            firstArg = anchorDate;
            secondArg = now.startOf('day').add(24, 'hours').add(-1, 'millisecond');
        }
        return {
            rootApply: undefined,
            clause: (qb)=>{
                qb.where((nestedQb)=>{
                    this.comparisonBetween(_extends({}, args, {
                        anchorDate: firstArg,
                        rangeDate: secondArg,
                        qb: nestedQb
                    }), rootArgs, _options);
                });
            }
        };
    }
    constructor(...args){
        super(...args), this.dateValueFormat = 'YYYY-MM-DD HH:mm:ss';
    }
};
